module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-07.09b5924c.png";